export const lang = {
  nav: {
    '分享给我的': 'Shared with meg',
    '浏览器管理': 'Browser Manage',
    '浏览器列表': 'Browser List',
    '分组': 'Grouping',
    '回收站': 'Recycle Bin',
    '我的帐户': 'My Account',
    '套餐管理': 'Package Manage',
    '子帐户管理': 'Sub Account Manage',
    '操作日志': 'Operation Log',
    '全局设置': 'Global Settings',
    '应用中心': 'Application Center',
    '帮助中心': 'Help Center',
    '推广奖励': 'Promotion Reward',
  },
  comm: {
    '复制成功': 'Copy success',
    '未知错误': 'unknown error',
    '基础信息': 'Basics',
    '操作系统': 'OS',
    '浏览器': 'Browser',
    '时区': 'Timezone',
    '位置': 'Location',
    '语言': 'Language',
    '提供商': 'Provider',
    '代理': 'Proxy',
    '分辨率': 'Screen size',
    '汇率计算': 'Exchange rate',
    '人民币': 'RMB',
    '美元': 'Dollar',
    '英镑': 'Pound',
    '欧元': 'Euro',
    '日元': 'Yen',
    '加币': 'Canadian dollar',
    '港币': 'HKD',
    'IP测试': 'IP test',
    '密码生成': 'Password generation',
    '复制安全密码': 'Copy security password',
    '刷新': 'Refresh',
    '位数': 'quantity',
    '组成': 'form',
    '小写': 'Lowercase',
    '大写': 'Uppercase',
    '特殊字符': 'Symbol',

    '你很安全': 'You are safe',
    '你很危险': 'You are danger',
    '我的IP': 'My IP',
    '开启': 'Open',
    '关闭': 'Close',
    '未开启': 'No open',
    '启用': 'Enable',
    '禁用': 'Disable',
    '蓝牙': 'Bluetooth',
    '充电状态': 'State of charge',
    '剩余电量': 'Remaining electricity',
    '电量可用时间': 'Power available time',
    '充电完成所需时间': 'Time required for charging',
    '指纹保护': 'Fingerprint protection',
    '绘图API': 'Drawing API',
    '文本API': 'Text API',
    'Canvas指纹': 'Canvas fingerprint',
    '图像文件': 'Image file',
    '图像信息': 'Image information',
    '宽': 'wide',
    '高': 'high',
    '文件大小': 'File size',
    '字节': 'Byte',
    '字体指纹': 'Font fingerprint',
    '字体列表': 'Font list',
    '支持': 'Yes',
    '不支持': 'No',
    '收起': 'Put away',
    '查看全部': 'View all',
    '联网': 'Networking',
    '断网': 'Network disconnection',
    '语言不同': 'Different languages',
    '客户端语言与HTTP请求Header中Accept': 'The client language is different from the accept language in the HTTP request header.',
    '未设置“勿追踪”功能': 'The "do not track" function is not set.',
    'WebDriver已开启': 'Webdriver turned on',
    'WebDriver是一个支持浏览器自动化的工具': 'Webdriver is a tool that supports browser automation. Normal browsers should be closed.',
    'Cookie已禁用': 'Cookies disabled',
    'Cookie是储存在用户本地终端上的数据': 'Cookies are data stored on the user\'s local terminal. Some websites store data on the user\'s local terminal for session tracking in order to identify the user\'s identity. The normal browser should be open.',
    '无剩余电量': 'No remaining power',
    '正常电脑或手机正在使用中时应该是有剩余电量': 'There should be residual power when the normal computer or mobile phone is in use.',
    'SpeechSynthesis未检测出信息': 'SpeechSynthesis no message detected',
    'SpeechSynthesis是语音服务的控制接口': 'SpeechSynthesis is the control interface of voice service. It can be used to obtain the information about the available synthetic sound on the device. The information should be detected by normal browsers.',
    'HTTP请求时Header未检测出信息': 'No message detected by header during HTTP request',
    'Header为HTTP请求时重要信息': 'The header is important information for HTTP requests and is also an indispensable part.',
    '系统字体列表未检测出信息': 'No information is detected in the system font list',
    '字体检测异常': 'Font detection exception',
    '字体列表与当前系统不匹配': 'The font list does not match the current system',
    '系统字体列表每台设备都会拥有': 'The system font list is owned by each device.',
    '移动端未检测出蓝牙设备': 'The mobile terminal does not detect a Bluetooth device',
    '蓝牙技术是一种无线数据和语音通信开放的全球规范': 'Bluetooth technology is an open global standard for wireless data and voice communication. It is a special short-range wireless technology connection based on low-cost short-range wireless connection to establish a communication environment for fixed and mobile devices. It should be owned by normal mobile terminal.',
    '基础': 'Basics',
    '视频输入设备': 'Video input device',
    '音频输入设备': 'Audio input device',
    '音频输出设备': 'Audio output device',
    'WebRtc未开启': 'Webrtc is not turned on',
    '经度': 'Longitude',
    '纬度': 'Latitude',
    '州': 'State',
    '国家': 'Country',
    '地区': 'Region',
    '城市': 'City',
    '媒体设备信息': 'Media device information',
    '未检测到设备': 'No device detected',
    '正在充电': 'Charging',
    '停止停电': 'Stop power failure',
    '浏览器不支持XMLHttpRequest无法检测': 'The browser does not support XMLHttpRequest and cannot be detected',
    '安徽铁脚印': 'Anhui tie jiao yin',
    'tips1': 'ipcs.vip is suitable for checking DNS of proxy IP addresses, operating system version, browser fingerprint, WebRTC leaks, location, language, etc.',
    'tips2': 'The core functionality and main advantage of the service is the interactive inspection of Java, Flash, and WebRTC, which can discover the real settings and weaknesses of the system, preventing other resources from learning information that you do not want to share yourself.',
    '分享链接': 'Share link',
    '取消': 'cancel',
    '复制': 'copy',



    'DNS与IP不在同一地区': 'DNS and IP are not in the same region',
    '你的DNS服务器所在的地区不同于你的IP地址所在的地区': 'Your DNS server is in a different zone (%s) than your IP address (%s). You may be hiding your location.',

    title: 'Browser fingerprint online detection website: proxy IP anti Association camouflage degree query tool',
    keywords: 'Proxy IP camouflage query, browser fingerprint online detection, browser fingerprint camouflage technology, browser fingerprint modification, webrtc detection, browser fingerprint spoofing tool, browser fingerprint simulation',
    description: 'ipcs. VIP is applicable to the detection and query tool website for checking agent IP detection, address, operating system version, UA, webrtc, canvas, browser fingerprint, webrtc leakage, location, language, etc.',
    '香港检测': 'Hong Kong testing',
    'WebRTC检测': 'WebRTC testing',
    '我的': 'My ',
  },
}



// WEBPACK FOOTER //
// ./src/i18n/en.js